// Simple Collection Navigation Slider
function initCollectionNavigationSlider() {
  const slider = document.querySelector('.collection-navigation-swiper');
  if (!slider) {
    return;
  }

  const scrollbar = slider.querySelector('.collection-navigation-scrollbar');
  const slides = slider.querySelectorAll('.swiper-slide');
  
  if (slides.length === 0) {
    return;
  }
  
  if (typeof Swiper === 'undefined') {
    return;
  }
  
  try {
    const swiper = new Swiper(slider, {
      loop: false,
      slidesPerView: 2.1,
      spaceBetween: 16,
      breakpoints: {
        750: {
          slidesPerView: 3.2,
          spaceBetween: 20
        },
        990: {
          slidesPerView: 4.2,
          spaceBetween: 30
        }
      },
      watchOverflow: true,
      observer: true,
      observeParents: true,
      scrollbar: {
        el: scrollbar,
        draggable: true,
        dragSize: 100,
        draggableTrack: true,
        draggableTrackClickable: true,
        hide: false,
        snapOnRelease: true
      },
      on: {
        init: function() {
          updateScrollbarVisibility(this);
        },
        resize: function() {
          updateScrollbarVisibility(this);
        }
      }
    });
    
    // Function to update scrollbar visibility
    function updateScrollbarVisibility(swiperInstance) {
      setTimeout(() => {
        const scrollbarEl = slider.querySelector('.swiper-scrollbar');
        if (scrollbarEl) {
          // Check if scrollbar should be visible
          const isScrollable = !swiperInstance.isEnd || !swiperInstance.isBeginning;
          const hasEnoughSlides = slides.length > 4;
          
          if (hasEnoughSlides || isScrollable) {
            scrollbarEl.style.display = 'block';
            scrollbarEl.style.visibility = 'visible';
            scrollbarEl.style.opacity = '1';
          } else {
            scrollbarEl.style.display = 'none';
          }
        }
      }, 300);
    }
    
    // Initial update
    updateScrollbarVisibility(swiper);

    // Desktop trackpad / mouse wheel horizontal scrolling.
    // Handled manually with Swiper's core translate methods instead of
    // its optional mousewheel module, so a missing module in this build
    // can't take down slider init the way it did before.
    try {
      const isDesktop = window.matchMedia('(min-width: 750px)').matches;

      if (isDesktop) {
        let wheelResetTimer;

        slider.addEventListener('wheel', function(e) {
          // Only handle horizontal input (trackpad side-swipes, tilt wheels).
          // Vertical input is left completely alone so the page scrolls normally.
          if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) {
            return;
          }

          const delta = e.deltaX;
          if (!delta) {
            return;
          }

          const atStart = swiper.isBeginning && delta < 0;
          const atEnd = swiper.isEnd && delta > 0;
          if (atStart || atEnd) {
            return; // let the page scroll normally at the edges
          }

          e.preventDefault();

          const newTranslate = swiper.translate - delta;
          swiper.setTranslate(newTranslate);
          swiper.updateProgress(newTranslate);

          if (typeof swiper.updateActiveIndex === 'function') {
            swiper.updateActiveIndex();
          }
          if (typeof swiper.updateSlidesClasses === 'function') {
            swiper.updateSlidesClasses();
          }

          clearTimeout(wheelResetTimer);
          wheelResetTimer = setTimeout(function() {
            if (typeof swiper.slideToClosest === 'function') {
              swiper.slideToClosest();
            }
          }, 150);
        }, { passive: false });
      }
    } catch (wheelError) {
      console.error('Error setting up wheel scroll:', wheelError);
    }
    
    return swiper;
  } catch (error) {
    console.error('Error initializing slider:', error);
  }
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCollectionNavigationSlider);
} else {
  initCollectionNavigationSlider();
}

// Also try after a delay
setTimeout(initCollectionNavigationSlider, 1000);

// Listen for Shopify section events
document.addEventListener('shopify:section:load', function(event) {
  if (event.target.querySelector('.collection-navigation-swiper')) {
    setTimeout(() => initCollectionNavigationSlider(), 100);
  }
});